'use strict';

module.exports = '3.23.1';
